import { memo } from 'react';
import { CircleFlagLanguage } from 'react-circle-flags';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/shared/components/ui/tooltip';
import { LANGUAGES_OBJ } from '@/shared/constants/languages';
import { cn } from '@/shared/utils/cn';

export interface ProfileLanguageFlagsProps {
  /**
   * Array of ISO 3166-1 alpha-2 country codes representing languages
   * @example ['us', 'br', 'cn', 'ar']
   */
  languageCodes: string[];
  className?: string;
  circleClassName?: string;
  limit?: number;
}

export const ProfileLanguageFlags = memo(
  ({
    languageCodes,
    className,
    circleClassName,
    limit = languageCodes.length,
  }: ProfileLanguageFlagsProps) => {
    if (languageCodes.length === 0) {
      return null;
    }

    return (
      <span className={cn('flex items-center gap-1', className)}>
        {languageCodes.slice(0, limit).map(code => {
          const languageName = LANGUAGES_OBJ[code]?.label ?? code;
          return (
            <Tooltip key={code}>
              <TooltipTrigger asChild>
                <span className={cn('size-3', circleClassName)}>
                  <CircleFlagLanguage languageCode={code} />
                </span>
              </TooltipTrigger>
              <TooltipContent>
                <p>Language: {languageName}</p>
              </TooltipContent>
            </Tooltip>
          );
        })}
      </span>
    );
  },
);

ProfileLanguageFlags.displayName = 'ProfileLanguageFlags';
